import React, { useEffect, useMemo, useState } from "react";
import "./styles.css";
import DashboardHeader from "../DashboardHeader/DashboardHeader";
import DebitCard from "./DebitCard";
import Location from "./Location";
import { useGlobalContext } from "../../../context/context";
import { toast } from "react-toastify";
import { FiCreditCard, FiRefreshCw, FiShield, FiArrowRight } from "react-icons/fi";

const readSession = (key) => {
  try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; }
};

const Card = () => {
  const [requestOpen, setRequestOpen] = useState(false);
  const { getUser, getAllCard, userCards, cardLoading, cardError, userDetails } = useGlobalContext();
  const cachedUser = useMemo(() => readSession("user") || {}, []);
  const user = userDetails && !Array.isArray(userDetails) && Object.keys(userDetails).length ? userDetails : cachedUser;
  const { firstName, _id, symbol, country, cardAmount, cardIssuing } = user;
  const token = readSession("accessToken");
  const activeCard = Array.isArray(userCards) ? userCards[0] : null;
  const currencySymbol = symbol || country?.symbol || "";

  const loadCard = () => {
    getUser(token, _id);
    getAllCard(token);
  };
  useEffect(() => {
    loadCard();
  }, []);

  const requestCard = () => {
    if (cardIssuing !== true) {
      toast.error("Card issuing is not available on this account. Please contact customer care.");
      return;
    }
    setRequestOpen(true);
  };

  return (
    <section className="pg-card-page">
      <div className="pg-card-topbar"><DashboardHeader pathname={firstName || "Account"} /></div>
      <main className="pg-card-content">
        <header className="pg-card-title">
          <div><span className="pg-card-eyebrow">ACCOUNT SERVICES / PAYMENT CARD</span><h1>Your ProfitGrowing card</h1><p>Manage your card request and check its current status.</p></div>
          <span className="pg-card-security"><FiShield size={15} /> Account protected</span>
        </header>
        {cardLoading ? (
          <section className="pg-card-state pg-card-loading" aria-label="Loading card status">
            <div className="pg-card-skeleton" /><div className="pg-card-skeleton-copy"><i /><b /><b /></div>
          </section>
        ) : cardError ? (
          <section className="pg-card-state pg-card-error" role="alert">
            <FiCreditCard size={25} /><h2>Card status unavailable</h2><p>We couldn't retrieve your card information. Your account has not been changed.</p>
            <button type="button" onClick={loadCard}><FiRefreshCw size={14} /> Try again</button>
          </section>
        ) : String(activeCard?.status || "").toLowerCase() === "approved" ? (
          <section className="pg-card-approved">
            <div className="pg-card-section-heading"><div><span className="pg-card-eyebrow">ACTIVE PAYMENT CARD</span><h2>Card details</h2></div><span className="pg-status-chip is-approved">Approved</span></div>
            <DebitCard
              card_number={activeCard.cardNumber}
              name={activeCard.name}
              ccv={activeCard.ccv}
              cardType={activeCard.cardType}
              createdAt={activeCard.createdAt}
            />
            <p className="pg-card-caption">Your card details are provided by your account. Keep them private and never share your security code.</p>
          </section>
        ) : activeCard ? (
          <section className="pg-card-state pg-card-pending">
            <div className="pg-card-pending-mark"><FiRefreshCw size={21} /></div>
            <div><span className="pg-card-eyebrow">REQUEST IN PROGRESS</span><h2>Card request {activeCard.status ? `· ${activeCard.status}` : "pending"}</h2><p>Your request is being reviewed. This page will reflect the card status when it is available.</p></div>
            <span className="pg-status-chip">{activeCard.status || "Pending"}</span>
          </section>
        ) : (
          <>
            <section className="pg-card-intro">
              <div className="pg-card-preview" aria-label="Decorative card preview">
                <div className="pg-card-preview-top"><span className="pg-card-emblem"><FiTrendingMark /></span><span>ProfitGrowing</span><FiCreditCard size={17} /></div>
                <div className="pg-card-preview-chip" aria-hidden="true"><span /><span /><span /><span /></div>
                <p className="pg-card-preview-title">DIGITAL ASSET CARD</p>
                <div className="pg-card-preview-bottom"><span>Card preview</span><span className="pg-card-circles" aria-hidden="true"><i /><i /></span></div>
              </div>
              <div className="pg-card-summary">
                <span className="pg-card-eyebrow">READY WHEN YOU ARE</span>
                <h2>A card for your account.</h2>
                <p>Review card issuing information and begin a request from your account. Card availability and delivery details depend on your account status and location.</p>
                <div className="pg-card-fee-row"><span>Issuing fee</span><strong>{cardAmount == null ? "Not available" : `${currencySymbol}${cardAmount}`}</strong></div>
                <div className="pg-card-fee-row"><span>Delivery</span><strong>Based on location</strong></div>
                <button type="button" className="pg-card-request-button" onClick={requestCard} data-testid="button-request-card">
                  {requestOpen ? "Request form opened" : "Continue to request"} <FiArrowRight size={15} />
                </button>
                {cardIssuing !== true && <p className="pg-card-support-note">Card issuing is not enabled for this account. Contact customer care for assistance.</p>}
              </div>
            </section>
            {requestOpen && (
              <section className="pg-card-request">
                <div className="pg-card-section-heading"><div><span className="pg-card-eyebrow">CARD REQUEST</span><h2>Delivery information</h2></div><button type="button" className="pg-card-close" onClick={() => setRequestOpen(false)}>Close</button></div>
                <Location />
              </section>
            )}
          </>
        )}
      </main>
    </section>
  );
};

const FiTrendingMark = () => <svg viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="m6 22 7-7 5 4 8-10M20 9h6v6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" /></svg>;

export default Card;
